<template>
  <q-page
    id="kitchen-summary-page"
    class="q-pa-sm overflow-hidden-y"
    @click="$emit('close')"
  >
    <transition-group
      name="list-complete"
      class="column grid-masonry"
      :style="{ 'max-height': pageHeight }"
      tag="span"
      appear
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
    >
      <kitchen-summary-item
        v-for="{ item_name, item_variation_name, modifiers, count } in summaryItems"
        :key="`${item_name}_${item_variation_name}_${modifiers.join('_')}`"
        class="list-complete-item q-ma-sm"
        style="min-width: 320px; max-width: 420px;"
        :style="{ 'max-height': pageHeight }"
        :item-name="item_name"
        :item-variation-name="item_variation_name"
        :modifiers="modifiers"
        :count="count"
        size="lg"
      />
    </transition-group>
  </q-page>
</template>

<script>
import KitchenSummaryItem from 'src/modules/kds/components/KitchenSummaryItem'

export default {
  name: 'KitchenSummaryPage',
  components: {
    KitchenSummaryItem
  },
  configuration: ['currentSite'],
  props: {
    summaryItems: {
      type: Array,
      required: true
    }
  },
  emits: ['close'],
  data () {
    return {
      pageHeight: '90vh'
    }
  },
  methods: {
    handlePageStyles (offset) {
      const pageHeight = offset ? `calc(100vh - ${offset}px)` : '90vh'

      this.pageHeight = pageHeight

      return { minHeight: pageHeight, maxHeight: pageHeight }
    }
  }
}
</script>

<style scoped>
.grid-masonry {
  flex-direction: column;
  align-content: flex-start;
}
.grid-masonry:after {
    content: '';
    flex: 1 0 100% !important;
    width: 0 !important;
}

.list-complete-item {
  transition: all 0.5s, border 1ms, outline 1ms, padding 1ms, margin 1ms;
}
.list-complete-enter {
  opacity: 0;
  transform: translateX(0) translateY(0);
}
.list-complete-leave-to {
  opacity: 0;
  transform: translateX(0) translateY(0);
}
.list-complete-leave-active {
  position: absolute;
  width: 100%;
}
</style>
